import Navbar from "../components/Navbar";
import HeroAnimated from "../components/HeroAnimated";
import FeaturesAnimated from "../components/FeaturesAnimated";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="app-shell">
      <Navbar />

      <HeroAnimated />

      <FeaturesAnimated />

      <Footer />
    </div>
  );
}
